document.addEventListener("DOMContentLoaded", function () {
  const endDate = new Date().getTime() + 24 * 60 * 60 * 1000; // Set deal expiration to 24 hours from now

  const timer = document.getElementById("countdown-timer");

  function updateTimer() {
    const now = new Date().getTime();
    const distance = endDate - now;

    if (distance <= 0) {
      timer.innerHTML = "Deal Ended";
      return;
    }

    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    timer.innerHTML = `${hours}h ${minutes}m ${seconds}s`;
  }

  updateTimer();
  setInterval(updateTimer, 1000);
});
